import React, { memo } from "react";
import { DgaIcon } from "platformscode-new-react";
import { useNavigate } from "react-router-dom";
import Card from "./Card";
function NewsCard({ data }) {
  const navigate = useNavigate();

  const cardStyle = {
    height: "100%",
    margin: "4px", // يحد من الارتفاع الأقصى
  };

  return (
    <>
      <Card
        style={cardStyle}
        image={data.img}
        title={data.title}
        description={data.description}
        primaryActionLabel="المزيد"
        showPrimaryAction={true}
        showSecondaryAction={false}
        overridePrimaryAction={() => navigate(`/news-details?id=${data.id}`)}

        showFeaturedIcon={false}
        effect="stroke"
      >


        <div className="flex gap-4">
          <DgaIcon
            color="#000000"
            icon="calendar-04"
            size={16}
            type=""
            variant="stroke"
          />
          <time style={{ fontSize: "14px" }}>
            {data.date}
          </time>
        </div>


      </Card>


      {/* <DgaCard
      ref={cardRef}
      style={cardStyle}
      image={data.img}
      cardTitle={data.title}
      description={data.description}
      primaryActionLabel="المزيد"
      showSecondaryAction={false}
      onPrimaryAction={() => navigate(`/news-details?id=${data.id}`)}
      showFeaturedIcon={false}
      effect="stroke"
    >


      <div className="flex gap-4">
        <DgaIcon
          color="#000000"
          icon="calendar-04"
          size={16}
          type=""
          variant="stroke"
        />
        <h4 style={{ fontSize: "14px" }}>
          {data.date}
        </h4>
      </div>


    </DgaCard> */}

    </>
  );
}

export default memo(NewsCard);
// return (
//       <div className="c-card card">
//          <img src={data.img}  height="300" alt="" className='top-image' srcset="" />
//          <div>
//          <h3>{data.title}</h3>
//          <p>{data.description}</p>
//          </div>
//          <span>{data.date}</span>
//          <div className="flex w-full justify-start gap-5 footer">
//          {/* <DgaButton
//              size="lg"
//              label="المزيد"
//              variant="neutral"
//            /> */}
//            <DgaButton
//              size="lg"
//              label="المزيد"
//              variant="primary-brand"
//            />

//          </div>
//        </div>

// );
